module.exports = __webpack_public_path__ + "images/gradients/gradient-volcano.13058897c7c441991b87.svg";